const LANG_NAMES: Record<string, string> = {
  ASM: 'Assamese', BHO: 'Bhojpuri', DIV: 'Dhivehi', DZO: 'Dzongkha',
  MAR: 'Marathi', MRI: 'Maori', NPI: 'Nepali', SIN: 'Sinhala', URD: 'Urdu',
  AEB: 'Tunisian Arabic',
  AFB: 'Gulf Arabic', APC: 'Levantine Arabic',
  ARB: 'Arabic (MSA)', ARY: 'Moroccan Arabic', ARZ: 'Egyptian Arabic',
  AZJ: 'Azerbaijani',
  BEL: 'Belarusian', BEN: 'Bengali', BUL: 'Bulgarian',
  CAT: 'Catalan', CES: 'Czech', CKB: 'Kurdish (Sorani)',
  CDO: 'Eastern Min (Fuzhou)',
  CMN_CN: 'Mandarin Chinese', CMN_TW: 'Mandarin (Taiwan)',
  CYM: 'Welsh', DAN: 'Danish', DEU: 'German',
  EKK: 'Estonian', ELL: 'Greek',
  ENG_AU: 'English (Australia)', ENG_GB: 'English (UK)', ENG_US: 'English (US)',
  EUS: 'Basque', FIN: 'Finnish', FRA: 'French',
  GLA: 'Scottish Gaelic', GLE: 'Irish',
  HAK: 'Hakka', HAK_HL: 'Hakka (Hailu)', HAK_SX: 'Hakka (Sixian)', HEB: 'Hebrew',
  HIN: 'Hindi', HRV: 'Croatian', HUN: 'Hungarian', HYE: 'Eastern Armenian',
  IND: 'Indonesian', ISL: 'Icelandic', ITA: 'Italian',
  JPN: 'Japanese', KAT: 'Georgian', KAZ: 'Kazakh',
  KHK: 'Mongolian (Khalkha)', KHM: 'Khmer', KOR: 'Korean',
  LAV: 'Latvian', LIT: 'Lithuanian',
  MKD: 'Macedonian', MYA: 'Burmese',
  NAN: 'Taiwanese Hokkien', NAN_CZ: 'Teochew', NAN_TW: 'Taiwanese Hokkien',
  NLD: 'Dutch', NOR: 'Norwegian',
  PES: 'Persian', POL: 'Polish',
  POR_BR: 'Portuguese (Brazil)', POR_PT: 'Portuguese (Portugal)',
  RON: 'Romanian', RUE: 'Rusyn', RUS: 'Russian',
  SLK: 'Slovak', SLV: 'Slovene',
  SPA_AR: 'Spanish (Argentina)', SPA_ES: 'Spanish (Spain)', SPA_MX: 'Spanish (Mexico)',
  SRP: 'Serbian', SWE: 'Swedish', SWH: 'Swahili',
  TAM: 'Tamil', TAT: 'Tatar', TGL: 'Tagalog', THA: 'Thai', TUR: 'Turkish',
  UIG: 'Uyghur', UKR: 'Ukrainian', UZN: 'Uzbek', VIE: 'Vietnamese',
  WUU_SH: 'Shanghainese Wu', WUU_WZ: 'Wenzhounese Wu',
  YUE_HK: 'Cantonese', YUE_TS: 'Taishan Cantonese',
  // Indic / Dravidian (added 2026-06-14)
  KAN: 'Kannada', TEL: 'Telugu', MAL: 'Malayalam', GUJ: 'Gujarati', NEP: 'Nepali',
  // New A0 targets (added 2026-06-14)
  LAO: 'Lao', NNO: 'Norwegian (Nynorsk)', GLV: 'Manx', SME: 'Northern Sami',
  HSB: 'Upper Sorbian', MLT: 'Maltese', SQI: 'Albanian', LTZ: 'Luxembourgish',
  // Expansion batch (added 2026-06-15)
  EPO: 'Esperanto', NOB: 'Norwegian (Bokmål)', DSB: 'Lower Sorbian',
  RMC: 'Carpathian Romani', RMY: 'Vlax Romani',
  SAH: 'Sakha (Yakut)', OSS: 'Ossetian', ABK: 'Abkhaz', ADY: 'Adyghe', CHE: 'Chechen',
  MHR: 'Eastern Mari', BAK: 'Bashkir', TGK: 'Tajik', KIR: 'Kyrgyz', UDM: 'Udmurt', CHV: 'Chuvash',
  BOD: 'Tibetan', ORI: 'Odia', JAV: 'Javanese', BAN: 'Balinese', CEB: 'Cebuano', ILO: 'Ilokano',
  ZUL: 'Zulu', YOR: 'Yoruba',
  // Jun15 A0 batch 2 (added 2026-06-15)
  PRS: 'Dari', TUK: 'Turkmen', PUS: 'Pashto (Northern)', PBT: 'Pashto (Southern)',
  PAN: 'Punjabi', AII: 'Assyrian Neo-Aramaic', TIR: 'Tigrinya', AMH: 'Amharic',
  KIN: 'Kinyarwanda', XHO: 'Xhosa', HAU: 'Hausa', FUL: 'Fula', LIN: 'Lingala', BAM: 'Bambara',
  // Latin / Celtic batch (added 2026-06-22)
  LAT: 'Latin', COR: 'Cornish', BRE: 'Breton',
};

// Autonyms: the language's own name for itself.
// Stored in lowercase canonical form for Latin-script languages.
// Capitalize first letter at render time when used sentence-initially.
// Exceptions that are always capitalized: Deutsch, English, Tiếng Việt.
// Non-Latin scripts have no case distinction.
const LANG_AUTONYMS: Record<string, string> = {
  AEB: 'تونسي', AFB: 'خليجي', APC: 'شامي',
  ARB: 'العربية', ARY: 'الدارجة', ARZ: 'مصري',
  AZJ: 'azərbaycanca',
  BEL: 'беларуская', BEN: 'বাংলা', BUL: 'български',
  CAT: 'català', CES: 'čeština', CKB: 'کوردی',
  CDO: '福州話',
  CMN_CN: '中文', CMN_TW: '國語',
  CYM: 'Cymraeg', DAN: 'dansk', DEU: 'Deutsch',
  EKK: 'eesti', ELL: 'ελληνικά',
  ENG_AU: 'English', ENG_GB: 'English', ENG_US: 'English',
  EUS: 'euskara', FIN: 'suomi', FRA: 'français',
  GLA: 'Gàidhlig', GLE: 'Gaeilge',
  HAK: '客家話', HAK_HL: '客家話海陸', HAK_SX: '客家話四縣', HEB: 'עברית',
  HIN: 'हिन्दी', HRV: 'hrvatski', HUN: 'magyar', HYE: 'հայերեն',
  IND: 'bahasa Indonesia', ISL: 'íslenska', ITA: 'italiano',
  JPN: '日本語', KAT: 'ქართული', KAZ: 'қазақша',
  KHK: 'монгол', KHM: 'ភាសាខ្មែរ', KOR: '한국어',
  LAV: 'latviešu', LIT: 'lietuvių',
  MKD: 'македонски', MYA: 'မြန်မာစာ',
  NAN: '臺語', NAN_CZ: '潮州話', NAN_TW: '臺語',
  NLD: 'Nederlands', NOR: 'norsk',
  PES: 'فارسی', POL: 'polski',
  POR_BR: 'português', POR_PT: 'português',
  RON: 'română', RUE: 'русиньскый', RUS: 'русский',
  SLK: 'slovenčina', SLV: 'slovenščina',
  SPA_AR: 'español', SPA_ES: 'español', SPA_MX: 'español',
  SRP: 'српски', SWE: 'svenska', SWH: 'Kiswahili',
  TAM: 'தமிழ்', TAT: 'татарча', TGL: 'Tagalog', THA: 'ภาษาไทย', TUR: 'türkçe',
  UIG: 'ئۇيغۇرچە', UKR: 'українська', UZN: 'ўзбекча', VIE: 'Tiếng Việt',
  VIE_HN: 'Tiếng Việt', VIE_SG: 'Tiếng Việt',
  WUU_SH: '上海話', WUU_WZ: '温州话',
  YUE_HK: '廣東話', YUE_TS: '台山話',
  KAN: 'ಕನ್ನಡ', TEL: 'తెలుగు', MAL: 'മലയാളം', GUJ: 'ગુજરાતી', NEP: 'नेपाली',
  LAO: 'ລາວ', NNO: 'nynorsk', GLV: 'Gaelg', SME: 'davvisámegiella',
  HSB: 'hornjoserbsce', MLT: 'Malti', SQI: 'shqip', LTZ: 'Lëtzebuergesch',
  EPO: 'Esperanto', NOB: 'bokmål', DSB: 'dolnoserbski', RMC: 'romani čhib', RMY: 'romani čhib',
  SAH: 'саха тыла', OSS: 'ирон æвзаг', ABK: 'аԥсшәа', ADY: 'адыгабзэ', CHE: 'нохчийн мотт',
  MHR: 'марий йылме', BAK: 'башҡортса', TGK: 'тоҷикӣ', KIR: 'кыргызча', UDM: 'удмурт кыл', CHV: 'чӑвашла',
  BOD: 'བོད་སྐད', ORI: 'ଓଡ଼ିଆ', JAV: 'ꦧꦱꦗꦮ', BAN: 'ᬩᬲᬩᬮᬶ', CEB: 'Cebuano', ILO: 'Ilokano',
  ZUL: 'isiZulu', YOR: 'Yorùbá',
  PRS: 'دری', TUK: 'türkmençe', PUS: 'پښتو', PBT: 'پښتو', PAN: 'ਪੰਜਾਬੀ',
  AII: 'ܣܘܪܝܬ', TIR: 'ትግርኛ', AMH: 'አማርኛ', KIN: 'Ikinyarwanda', XHO: 'isiXhosa',
  HAU: 'Hausa', FUL: 'Fulfulde', LIN: 'Lingála', BAM: 'bamanankan',
};

const CUSTOM_LANG_NAMES: Record<string, string> = {};

export function langName(code: string): string {
  return CUSTOM_LANG_NAMES[code] ?? LANG_NAMES[code] ?? code;
}

export function langAutonym(code: string): string {
  return LANG_AUTONYMS[code] ?? langName(code);
}

export function setCustomLangName(code: string, name: string): void {
  if (!LANG_NAMES[code]) {
    CUSTOM_LANG_NAMES[code] = name;
  }
}

export function hasLangName(code: string): boolean {
  return code in LANG_NAMES || code in CUSTOM_LANG_NAMES;
}

export { LANG_NAMES, LANG_AUTONYMS };
